/**
 * ページ本文に置く吹き出しや赤ポチを、固定ヘッダー (z-50) とモーダル (200) より下に出すための z-index。
 * Mantine の既定値は Popover が 300、Indicator が 100 で、どちらもヘッダーとモーダルの手前に出てしまう。
 */
export const Z_INDEX_BELOW_FIXED_HEADER = 40;
